import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";

let token = localStorage.getItem("accessToken");
let config_headers = {
  headers: {
    Authorization: "Bearer " + token
  }
};

const state = {
  isLoadMenus: false,
  flagDataMenus: true,
  errorMenus: "",
  menus: [],
  menusSearchResult: null,
  currentRestau: null,
  conversationsMenus: null,
  menuItem: {},
  itemsrates : {}
};

const getters = {
  menuItem: state => state.menuItem,
  isLoadMenus: state => state.isLoadMenus,
  isLoadMenus: state => state.isLoadMenus,
  flagDataMenus: state => state.flagDataMenus,
  errorMenus: state => state.errorMenus,
  menus: state => state.menus,
  currentRestau: state => state.currentRestau,
  itemsrates: state => state.itemsrates
};

const mutations = {
  getMenusSuccess(state, payload) {
    state.isLoadMenus = true;
    state.menus = payload.menus;
    state.currentRestau = payload.currentRestau;
  },
  addMenusSuccess(state, payload) {
    state.isLoadMenus = true;
    let menus = state.menus;
    menus.push(payload.data);
    state.menus = menus;
  },
  editMenusSuccess(state, payload) {
    state.isLoadMenus = true;
    let menus = state.menus;
    let item_index = -1;
    let newMenus = [];
    menus.map((menu, index) => {
      if (menu._id == payload.data._id) {
        newMenus.push({ ...payload.data });
      } else {
        newMenus.push({ ...menu });
      }
    });

    state.menus = [...newMenus];
  },

  setMenusSuccess(state, payload) {
    state.menuItem = payload;
  },
  getMenusError(state, error) {
    state.isLoadMenus = false;
    state.errorMenus = error;
  },
  addMenusError(state, error) {
    state.isLoadMenus = false;
    state.errorMenus = error;
  },
  loadedMenus(state, payload) {
    state.flagDataMenus = payload;
  },

  getItemsRatesSuccess(state, payload) {
    state.itemsrates = payload || {};
  }
};

const actions = {
  getMenusBySlug({ commit }, payload) {
    return axios
      .get(
        `${apiPath}/getMenusBySlug?slug=${payload.slug}&restaurant=${payload.restaurant}`
      )
      .then(r => r)
      .catch(r => r);
  },
  getMenuRecords({ commit }, payload) {
    return axios
      .get(`${apiPath}/menusRecords?restaurant=${payload}`)
      .then(r => r)
      .catch(r => r);
  },
  uploadFile({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/menus-excel`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("editMenusSuccess", res);
          console.log("SUCCES");
        } else {
          console.log("ERRORS");
        }
        return res.data;
      });
  },
  deleteMenus({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .delete(`${apiPath}/menus/${payload._id}`, config_headers)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deleteRestaurantSuccess", payload);
        // } else {
        //   commit("addRestaurantError", "error:addRestaurant");
        // }
        return payload;
      });
  },
  setMenus({ commit }, payload) {
    commit("setMenusSuccess", payload);
  },
  getMenus({ commit }, payload) {
    axios
      .get(`${apiPath}/menus?restaurant=${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getMenusSuccess", {
            menus: res.data,
            currentRestau: res.restau
          });
        } else {
          commit("getMenusError", "error:getMenus");
        }
      });
  },
  generateMenu({ commit }, payload) {
    console.log("%c HEY FROM GENERATE MENU", "color:gray;font-size:16px");
    console.log(payload);
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    if (payload.type == "RES") {
      return axios
        .get(`${apiPath1}/rest/generate/${payload.rvc}`, config_headers)
        .then(r => r.data)
        .then(res => {
          return res;
        });
    } else {
      return axios
        .get(
          `${apiPath}/generate/menu/${payload.slug}/${payload.rvc}`,
          config_headers
        )
        .then(r => r.data)
        .then(res => {
          return res;
        });
    }
  },
  async addMenuRecord({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    let data = await axios
      .post(`${apiPath}/menuRecord`, payload, config_headers)
      .then(r => r);
    return data;
  },
  async controllerMenus({ dispatch }, payload) {
    console.log(payload);
    for (let index = 0; index < payload.length; index++) {
      let payloadToApi = { ...payload[index] };
      console.log(payloadToApi);
      if (payloadToApi._id) {
        await dispatch("editMenus", payloadToApi);
      } else {
        payloadToApi = { ...payloadToApi, restau: payload.restau };
        console.log("%c FROOOOOM ", "color:orange;font-size:24px;");
        console.log(payloadToApi);
        await dispatch("addMenus", payloadToApi);
      }
    }
    return true;
  },
  async addMenus({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    let data = await axios
      .post(`${apiPath}/menus`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("addMenusSuccess", res);
        } else {
          // alert(res.message);
          // location.reload();
          // commit("addMenusError", "error:addMenus");
        }
        return res;
      });
    return data;
  },
  async editMenus({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    let data = await axios
      .post(`${apiPath}/menus/${payload._id}`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("editMenusSuccess", res);
        } else {
          // commit("addMenusError", "error:addMenus");
        }
        return res;
      });
    return data;
  },
  uploadImageItem({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/menus-uploadimage`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("editMenusSuccess", res);
          console.log("SUCCES");
        } else {
          console.log("ERRORS");
        }
        return res;
      });
  },
  uploadImageCategorie({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/categories-uploadimage`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("editMenusSuccess", res);
          console.log("SUCCES");
        } else {
          console.log("ERRORS");
        }
        return res;
      });
  },
  uploadImageSubCategorie({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/subCategories-uploadimage`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("editMenusSuccess", res);
          console.log("SUCCES");
        } else {
          console.log("ERRORS");
        }
        return res;
      });
  },

  async getItemsRates({ commit }, payload){
    commit("getItemsRatesSuccess", {});
    token = localStorage.getItem("accessToken");
    config_headers = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return await axios
    .get(`${apiPath}/items-rates/${payload.restaurant}/${payload.menu}?item_id=${payload.item_id}`, config_headers)
    .then(r => r.data)
    .then(res => {
        if (res.ok) {            
          commit("getItemsRatesSuccess", res.data);
        } 
        return res
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
